import * as types from './AlliesTypes';

export default function AlliesReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_ALLIES:
            return {
                ...state,
                getAllies: {
                    ...state.getAllies,
                    allies: payload.data,
                    firstAlly: payload.first,
                    lastAlly: payload.last,
                    nextAllies: payload.next,
                    alliesFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_ALLIES_LOADING:
            return {
                ...state,
                getAllies: {
                    ...state.getAllies,
                    loading: true
                },
            };
        case types.GET_ALLIES_ERROR:
            return {
                ...state,
                getAllies: {
                    ...state.getAllies,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ALLIES_ALL_MONTH:
            return {
                ...state,
                getAlliesAllMonth: {
                    ...state.getAlliesAllMonth,
                    allies: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_ALLIES_ALL_MONTH_LOADING:
            return {
                ...state,
                getAlliesAllMonth: {
                    ...state.getAlliesAllMonth,
                    loading: true
                },
            };
        case types.GET_ALLIES_ALL_MONTH_ERROR:
            return {
                ...state,
                getAlliesAllMonth: {
                    ...state.getAlliesAllMonth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ALLIES_BY_ID:
            return {
                ...state,
                getAlliesById: {
                    ...state.getAlliesById,
                    ally: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_ALLIES_BY_ID_LOADING:
            return {
                ...state,
                getAlliesById: {
                    ...state.getAlliesById,
                    loading: true,
                },
            };
        case types.GET_ALLIES_BY_ID_ERROR:
            return {
                ...state,
                getAlliesById: {
                    ...state.getAlliesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.UPDATE_ALLIES_BY_ID:
            return {
                ...state,
                updateAlliesById: {
                    ...state.updateAlliesById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getAlliesById: {
                    ...state.getAlliesById,
                    ally: {
                        ...state.getAlliesById.ally,
                        isApproved: payload.newIsApproved,
                        status: payload.newStatus,
                        usuarioAtendio: payload.newUserAttends,
                        nombreOdoo: payload.newOdooName,
                        comentario: payload.newCommentary
                    },
                },
            };
        case types.UPDATE_ALLIES_BY_ID_LOADING:
            return {
                ...state,
                updateAlliesById: {
                    ...state.updateAlliesById,
                    loading: true
                },
            };
        case types.UPDATE_ALLIES_BY_ID_ERROR:
            return {
                ...state,
                updateAlliesById: {
                    ...state.updateAlliesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ALLIES_FILTER:
            return {
                ...state,
                getAllies: {
                    ...state.getAllies,
                    alliesFilter: payload.data,
                    firstAlly: payload.first,
                    lastAlly: payload.last,
                    nextAllies: payload.next,
                    loading: false
                },
            };
        case types.GET_ALLIES_FILTER_LOADING:
            return {
                ...state,
                getAllies: {
                    ...state.getAllies,
                    loading: true
                },
            };
        case types.GET_ALLIES_FILTER_ERROR:
            return {
                ...state,
                getAllies: {
                    ...state.getAllies,
                    alliesFilter: [],
                    loading: false
                },
            };
        case types.GET_ALLIES_EXCEL:
            return {
                ...state,
                getAlliesExcel: {
                    ...state.getAlliesExcel,
                    allies: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_ALLIES_EXCEL_LOADING:
            return {
                ...state,
                getAlliesExcel: {
                    ...state.getAlliesExcel,
                    loading: true
                },
            };
        case types.GET_ALLIES_EXCEL_ERROR:
            return {
                ...state,
                getAlliesExcel: {
                    ...state.getAlliesExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_ALLIES_FILTER_EXCEL:
            return {
                ...state,
                getAlliesExcel: {
                    ...state.getAlliesExcel,
                    alliesFilter: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_ALLIES_FILTER_EXCEL_LOADING:
            return {
                ...state,
                getAlliesExcel: {
                    ...state.getAlliesExcel,
                    loading: true
                },
            };
        case types.GET_ALLIES_FILTER_EXCEL_ERROR:
            return {
                ...state,
                getAlliesExcel: {
                    ...state.getAlliesExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.ALLIES_EXCEL_RESET_STATE:
            return {
                ...state,
                getAlliesExcel: {
                    allies: [],
                    alliesFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_TYPES_ALLIES:
            return {
                ...state,
                getTypesAllies: {
                    ...state.getTypesAllies,
                    types: payload.data,
                    firstType: payload.first,
                    lastType: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_TYPES_ALLIES_LOADING:
            return {
                ...state,
                getTypesAllies: {
                    ...state.getTypesAllies,
                    loading: true,
                },
            };
        case types.GET_TYPES_ALLIES_ERROR:
            return {
                ...state,
                getTypesAllies: {
                    ...state.getTypesAllies,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CREATE_TYPES_ALLIES:
            return {
                ...state,
                createAlliesTypes: {
                    ...state.createAlliesTypes,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_TYPES_ALLIES_LOADING:
            return {
                ...state,
                createAlliesTypes: {
                    ...state.createAlliesTypes,
                    loading: true,
                },
            };
        case types.CREATE_TYPES_ALLIES_ERROR:
            return {
                ...state,
                createAlliesTypes: {
                    ...state.createAlliesTypes,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.DELETE_TYPES_ALLIES:
            return {
                ...state,
                deleteAlliesTypes: {
                    ...state.deleteAlliesTypes,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getTypesAllies: {
                    ...state.getTypesAllies,
                    types: payload,
                },
            };
        case types.DELETE_TYPES_ALLIES_LOADING:
            return {
                ...state,
                deleteAlliesTypes: {
                    ...state.deleteAlliesTypes,
                    loading: true,
                },
            };
        case types.DELETE_TYPES_ALLIES_ERROR:
            return {
                ...state,
                deleteAlliesTypes: {
                    ...state.deleteAlliesTypes,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.DELETE_TYPES_ALLIES_RESET_STATE:
            return {
                ...state,
                deleteAlliesTypes: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.VERIFY_ALLY_BY_ID:
            return {
                ...state,
                verifyAlly: {
                    ...state.verifyAlly,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.VERIFY_ALLY_BY_ID_LOADING:
            return {
                ...state,
                verifyAlly: {
                    ...state.verifyAlly,
                    loading: true
                },
            };
        case types.VERIFY_ALLY_BY_ID_ERROR:
            return {
                ...state,
                verifyAlly: {
                    ...state.verifyAlly,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.VERIFY_ALLY_BY_ID_RESET_STATE:
            return {
                ...state,
                verifyAlly: {
                    ...state.verifyAlly,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_COMMISSIONS_ALLY:
            return {
                ...state,
                updateCommissionsAlly: {
                    ...state.updateCommissionsAlly,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_COMMISSIONS_ALLY_LOADING:
            return {
                ...state,
                updateCommissionsAlly: {
                    ...state.updateCommissionsAlly,
                    loading: true
                },
            };
        case types.UPDATE_COMMISSIONS_ALLY_ERROR:
            return {
                ...state,
                updateCommissionsAlly: {
                    ...state.updateCommissionsAlly,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_COMMISSIONS_ALLY_RESET_STATE:
            return {
                ...state,
                updateCommissionsAlly: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_ALLIES_RESET_STATE:
            return {
                ...state,
                getAllies: {
                    allies: [],
                    firstAlly: null,
                    lastAlly: null,
                    nextAllies: null,
                    alliesFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            }
        case types.ALLIES_RESET_STATE:
            return {
                getAllies: {
                    allies: [],
                    firstAlly: null,
                    lastAlly: null,
                    nextAllies: null,
                    alliesFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getAlliesAllMonth: {
                    allies: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getAlliesById: {
                    ally: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getTypesAllies: {
                    types: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                verifyAlly: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getAlliesExcel: {
                    allies: [],
                    alliesFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
    
        default:
            return state;
    }
}